import React from 'react';
import { Row, Col, Card, Table, Progress, Space, Typography } from 'antd';
import { mockAdaptationData } from '../data/mockData';

const { Text } = Typography;

const AdaptationsTab: React.FC = () => {
  const adaptationColumns = [
    {
      title: 'Adaptation',
      dataIndex: 'adaptation',
      key: 'adaptation',
      render: (text: string) => <Text strong>{text}</Text>,
    },
    {
      title: 'Exercises',
      dataIndex: 'exercises',
      key: 'exercises',
      sorter: (a: any, b: any) => a.exercises - b.exercises,
    },
    {
      title: 'Coverage',
      dataIndex: 'coverage',
      key: 'coverage',
      render: (coverage: number) => (
        <Space>
          <Progress 
            percent={coverage} 
            size="small" 
            showInfo={false}
            strokeColor={coverage >= 90 ? '#52c41a' : coverage >= 70 ? '#faad14' : '#f5222d'}
          />
          <Text>{coverage}%</Text>
        </Space>
      ),
      sorter: (a: any, b: any) => a.coverage - b.coverage,
    },
  ];

  return (
    <Row gutter={[24, 24]}>
      <Col span={24}>
        <Card title="Adaptation Coverage Analysis" size="small">
          <Table
            dataSource={mockAdaptationData}
            columns={adaptationColumns}
            pagination={false}
            size="small"
            rowKey="adaptation"
          />
        </Card>
      </Col>
      <Col span={24}>
        <Card title="Exercise-Adaptation Mapping" size="small">
          <div style={{ height: 300, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <Text type="secondary">Exercise-adaptation relationship chart would be displayed here</Text>
          </div>
        </Card>
      </Col>
    </Row>
  );
};

export default AdaptationsTab; 